<span class="badge"
    [class.badge-success]="isSituacaoAtiva()"
    [class.badge-danger]="isSituacaoInativa()">
    {{situacao | naturezaVendaSituacao}}
</span>